<div class="plano-contas-tree-container">
  <div class="header d-flex justify-content-between align-items-center mb-3">
    <h1>Plano de Contas</h1>
    <div class="header-actions">
      <button class="btn btn-primary mr-2" (click)="novoRaiz(modalCadastro)">
        <i class="fa fa-plus mr-1"></i>Nova raiz
      </button>
      <button class="btn btn-outline-primary" (click)="carregarArvore()">
        <i class="fa fa-refresh mr-1"></i>Atualizar
      </button>
    </div>
  </div>

  <div class="card-box">
    <ng-container *ngIf="arvore?.length; else semDados">
      <ng-container *ngTemplateOutlet="treeTemplate; context: { $implicit: arvore, nivel: 0 }"></ng-container>
    </ng-container>
    <ng-template #semDados>
      <div class="text-muted">Nenhuma conta cadastrada.</div>
    </ng-template>
  </div>

  <ng-template #treeTemplate let-nos let-nivel="nivel">
    <ul class="tree-level" [class.root-level]="nivel === 0">
      <li class="tree-node" *ngFor="let item of nos">
        <div class="node-line" [ngClass]="{ 'is-sintetica': isTipoSintetica(item.tipo) }">
          <button *ngIf="hasFilhos(item)" type="button" class="btn-toggle" (click)="toggle(item)">
            <span>{{ isExpandido(item) ? '−' : '+' }}</span>
          </button>
          <span *ngIf="!hasFilhos(item)" class="leaf-dot"></span>
          <span class="node-marker" [ngClass]="classeMarcador(item)"></span>
          <span class="node-text" [ngClass]="classeTexto(item)">
            {{ item.codigo }} - {{ item.nome }}
          </span>
          <div class="node-actions">
            <button *ngIf="isTipoSintetica(item.tipo)" type="button" class="btn btn-outline-success btn-sm" (click)="novoFilho(item, modalCadastro)">
              <i class="fa fa-plus mr-1"></i>Filho
            </button>
            <button type="button" class="btn btn-outline-primary btn-sm" (click)="editar(item, modalCadastro)">
              <i class="fa fa-pencil mr-1"></i>Editar
            </button>
            <button type="button" class="btn btn-outline-danger btn-sm" (click)="remover(item)">
              <i class="fa fa-trash mr-1"></i>Remover
            </button>
          </div>
        </div>

        <ng-container *ngIf="hasFilhos(item) && isExpandido(item)">
          <ng-container *ngTemplateOutlet="treeTemplate; context: { $implicit: item.filhos, nivel: nivel + 1 }"></ng-container>
        </ng-container>
      </li>
    </ul>
  </ng-template>

  <ng-template #modalCadastro let-modal>
    <div class="modal-header">
      <h5 class="modal-title">{{ editandoId > 0 ? 'Editar Conta' : 'Nova Conta' }}</h5>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row g-3">
        <div class="col-md-4">
          <label class="form-label">Código *</label>
          <input type="text" class="form-control" [(ngModel)]="codigo" />
        </div>
        <div class="col-md-8">
          <label class="form-label">Nome *</label>
          <input type="text" class="form-control" [(ngModel)]="nome" />
        </div>
        <div class="col-md-4">
          <label class="form-label">Tipo *</label>
          <select class="form-control" [(ngModel)]="tipo">
            <option value="SINTETICA">SINTETICA</option>
            <option value="ANALITICA">ANALITICA</option>
          </select>
        </div>
        <div class="col-md-4">
          <label class="form-label">Natureza *</label>
          <select class="form-control" [(ngModel)]="natureza">
            <option value="ENTRADA">ENTRADA</option>
            <option value="SAIDA">SAIDA</option>
          </select>
        </div>
        <div class="col-md-4">
          <label class="form-label">Conta Pai</label>
          <select class="form-control" [(ngModel)]="contaPaiId">
            <option [ngValue]="null">Nenhuma</option>
            <option *ngFor="let item of contasPaiDisponiveis" [ngValue]="item.id">
              {{ item.codigo }} - {{ item.nome }}
            </option>
          </select>
        </div>
        <div class="col-md-4 d-flex align-items-end">
          <div class="form-check">
            <input id="ativoPlanoContaTree" class="form-check-input" type="checkbox" [(ngModel)]="ativo" />
            <label for="ativoPlanoContaTree" class="form-check-label">Ativo</label>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" (click)="modal.dismiss()">Cancelar</button>
      <button class="btn btn-success" (click)="salvar()">Salvar</button>
    </div>
  </ng-template>
</div>
